{
  "steplist": "Lista kroków"
}
